import GestantesPuerperasIcon from '@/components/icons/IndicadoresAps/eSFeAP/GestantesPuerperas.vue'

export default {
  value: 'c3',
  label: 'Gestantes puérperas',
  iconType: 'component',
  iconComponent: GestantesPuerperasIcon,
  buscaAtiva: {
    a: 'Mulher sem ter realizado a primeira consulta de pré-natal até 12 semanas de gestação.',
    b: 'Mulher deveria ter realizado consulta(s) de pré-natal até o momento.',
    c: 'Mulher deveria ter realizado registro(s) de aferição de PA até o momento.',
    d: 'Mulher deveria ter realizado registro(s) de peso e altura até o momento.',
    e: 'Mulher deveria ter recebido visita(s) domiciliares do ACS/Tacs até o momento.',
    f: 'Mulher deveria ter registro de uma dose de dTpa a partir da 20ª semana de cada gestação.',
    g: 'Mulher deveria ter registro dos testes rápidos ou dos exames avaliados para sífilis, HIV e hepatites B e C realizados no primeiro trimestre de cada gestação.',
    h: 'Mulher deveria ter registro dos testes rápidos ou dos exames avaliados para sífilis e HIV realizados no terceiro trimestre de cada gestação.',
    i: 'Mulher deveria ter registro de consulta presencial ou remota por profissional médica(o) ou enfermeira(o) realizada durante o puerpério.',
    j: 'Mulher deveria ter registro de visita domiciliar por ACS/Tacs realizada durante o puerpério.',
    k: 'Mulher deveria ter registro de avaliação odontológica realizada durante o período da gestação por profissional cirurgiã(ão) dentista.',
  },
}
